// extracted by mini-css-extract-plugin
export default {"wrapper":"introduction5_wrapper__lU1rF","button":"introduction5_button__hQ08G"};